import { useEffect, useState } from "react";
import { ToTopBtn } from "../index";
type Props = {
  element: HTMLElement;
};

export const ReuseGoToTopBtn = ({ element }: Props) => {
  const [showScrollTop, setShowScrollTop] = useState<boolean>(false);

  useEffect(() => {
    if (element) {
      const handleScroll = () => {
        const { top } = element.getBoundingClientRect();

        setShowScrollTop(top <= -200);
      };

      window.addEventListener("scroll", handleScroll);

      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return showScrollTop ? <ToTopBtn /> : null;
};
